module.exports = "/assets//img/8ef4c936807fd6dd64dd43f92f227f0d.svg";